import { domain } from "../../domain";

export {
    unitType
}

function unitType(per_page=null,page=null,id=null,name=null,orderBy=null){
    if(id){
        return `${domain}/pos/get-pos-unit-type?id=${id}`;
    } else if(name){
        return `${domain}/pos/get-pos-unit-type?per_page=${per_page}&page=${page}&name=${name}&orderBy=${orderBy}`
    } else {
        return `${domain}/pos/get-pos-unit-type?per_page=${per_page}&page=${page}&orderBy=${orderBy}`;
    }
}